import { useEffect, useCallback, useRef } from "react";

export default function SlideUp({children, delay=0, top=100}){

  const ref = useRef();

  const appear = useCallback(()=>{
    if(window.innerHeight > ref.current.getBoundingClientRect().top+top){
      setTimeout(()=>{
        ref.current?.classList.add(`slideUp`)
        setTimeout(()=>{
          ref.current?.classList.remove('opacity-0');
          ref.current?.classList.remove(`translate-y-[30%]`)
        }, 2900)
      }, delay);
    }
  },[delay, top]);

  useEffect(()=>{
    window.addEventListener('scroll', appear);
    return () => {
      window.removeEventListener('scroll', appear); 
    };
  },[appear]);

  return (
    <div ref={ref} className={`opacity-0 translate-y-[30%]`}>
      {children}
    </div>
  );

}